<template lang="pug">
  #users-actions.center-panel.md-scrollbar.md-theme-default
    md-content.md-elevation-1(md-theme="white")
      user-menu
      .md-flex(md-theme="white" v-loader-overlay="progress")
        md-table(md-theme="white")
          md-table-row(v-for="action in actions" v-bind:key="action.id" v-bind:class="($route.params.action_code && $route.params.action_code == action.code) ? 'action-row hovered' : 'action-row'")
            md-table-cell
              div.row-container
                //router-link.small.md-primary(v-bind:to="{ name: 'UserModuleAction', params: {code: $route.params.code, action_code: action.code}, query: $route.query }")
                span.md-layout-row.md-gutter
                    span.md-flex.name {{action.name + ' (' + action.code + ')'}}

                div.action-groups(v-if="usersGroups && usersGroups.length && action.groups" v-bind:class="{'loading': loading}")
                  md-button.md-primary.md-icon-button.md-dense.small(@click="save(action)")
                    md-icon check
                    md-tooltip(md-direction="bottom" md-delay="500") Сохранить
                  md-field
                    md-select(v-model="action.groups" name="groups" id="groups" md-dense multiple placeholder="Группы пользователей" v-bind:disabled="loading" )
                      md-option(v-for="group in usersGroups" v-bind:value="group.code" v-bind:key="group.id") {{group.name}}
                  
</template>
<script>
  import UserMenu from './menu.vue';

  export default {
      data() {
        return {
          loading: false,
        }
      },
      components: {UserMenu},
      computed: {
        usersGroups() { //все групппы пользователей
          return this.$store.state.users.groups;
        },
        progress() {
            return this.progressObj['get-users-actions-list'];
        },
        progressObj() {
            return this.$store.state.progressObj;
        },
        actions() {
          return this.$store.state.module.actions;
        }
      },
      created() {
        this.getModuleActions();
        this.getUserGroups();
      },
      methods: {
        save(action) {
          this.loading = true;
          let actions = [],
              groups  = [];

          action.groups.map(group => {
            groups.push(group);
            actions.push({
              group_code: group,
              module_code: this.$route.params.code,
              name:        action.code,
              description: action.name,
              sort: 100
            })
          });

          this.$store.dispatch('module/postUserGroupsToAction', {
            actions: actions,
            groups: groups,
            module_code: this.$route.params.code,
            action_code: action.code,
          }).then(r => {
            if (r) this.$store.commit('showSnackbar', ['Группы успешно сохранены', 6000]);
          }).finally(() => this.loading = false);

        },
        getModuleActions() {
            this.$store.commit('showProgressBar', 'get-users-actions-list');
            this.$store.dispatch('module/getModuleActions', this.$route.params.code).then(() => {
                this.$store.commit('hideProgressBar', 'get-users-actions-list');
            });
        },
        getUserGroups() { //получение всех групп пользователей
          if (!this.$store.state.users.groups.length) {
            this.$store.dispatch('users/getUsersGroups');
          }
        },
      }
  }
</script>
<style scoped lang="sass">
  #users-actions
    .row-container
      display: flex
      align-items: center
      justify-content: space-between
      .action-groups
        width: 60%
        display: flex
        align-items: center
        justify-content: flex-end
        position: relative
        transition: 0.5s ease-in-out
        .md-select
          padding-left: 30px
        .md-button
          transform: translate(25px, 5px)
      .action-groups.loading
        opacity: 0.5
    .action-row.hovered
      .md-table-cell
        background-color: var(--md-theme-default-highlight-on-background, rgba(0, 0, 0, 0.08));
</style>



// WEBPACK FOOTER //
// Actions.vue?78eefdc2